import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function Project_files() {
    const navigate = useNavigate();
    const active_pro_name = localStorage.getItem('selected_project_name');
    const [listProjectFilesArray, setListProjectFilesArray] = useState([]);
     const [membretype, setMembertype] = useState(false);
    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        const active_pro_id = localStorage.getItem('selected_project_id');

        var obj = {
            project_id: active_pro_id
        };
        console.log(obj);
        fetch('getFilesOfProject.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.status === "success" && Array.isArray(result.files)) {
                    if (result.files.length < 1) {
                        showAlert('Cannot find any file for this project.');
                    } else {
                        setListProjectFilesArray(result.files);
                    }
                } else {
                    setListProjectFilesArray([]);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }, []);


    // Detect image file
    const isImage = (fileName) => {
        return /\.(jpg|jpeg|png|gif|webp)$/i.test(fileName);
    };

    // View handler
    const handleView = (file) => {
        const url = file.file_path;

        if (isImage(file.file_name) || file.file_name.endsWith('.pdf')) {
            window.open(url, '_blank');
        } else if (file.file_name.endsWith('.doc') || file.file_name.endsWith('.docx')) {
            window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`, '_blank');
        } else {
            handleDownload(file);
        }
    };

    // Download handler
    const handleDownload = (file) => {
        const link = document.createElement('a');
        link.href = file.file_path;
        link.download = file.file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    function openAddFilePOP() {
        document.getElementById('addfile').classList.remove('nodisplay')
    }
    function closeAddFilePOP() {
        document.getElementById('addfile').classList.add('nodisplay')
    }
    const uploadfiles = () => {
        const fileInput = document.getElementById('project_file');
        const description = document.getElementById('file_description').value;

        const file = fileInput.files[0];

        if (!file) {
            alert("Please select a file");
            return;
        }

        const active_pro_id = localStorage.getItem('selected_project_id');
        const active_pro_name = localStorage.getItem('selected_project_name');

        const formData = new FormData();
        formData.append("file", file);
        formData.append("description", description);
        formData.append("pro_id", active_pro_id);
        formData.append("pro_name", active_pro_name);

        fetch('uploadProjectFile.php', {
            method: 'POST',
            body: formData
        })
            .then(res => res.json())
            .then(result => {
                console.log(result);

                if (result.status === "success") {
                    showAlert("File uploaded successfully");
                    localStorage.setItem('initialpage', 'files');
                    navigate('/redirect_task');
                    // refresh list

                } else {
                    alert(result.message);
                }
            })
            .catch(err => {
                console.error(err);
            });
    };
    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }
    return (
        <div>
            <div className='topbar_menu'>

                <button className='member_button  addmembtn' onClick={openAddFilePOP}>Add File</button>

                <p>Files for {active_pro_name}</p>

            </div>
            <div className='member_row'>
                <div className='member_details'>
                    <section className='vl_dsh_bodypart_section pos_rel'>
                        <div className='vl_listing_area'>
                            {listProjectFilesArray.map((file, index) => (
                                <div className='fileblock' key={index}>

                                    <div className='fullwidth pull_left'>

                                        <div className='imgbllock'>
                                            {isImage(file.file_name) ? (
                                                <img
                                                    src={file.file_path}
                                                    alt={file.file_name}
                                                    style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                            ) : (
                                                <img
                                                    src="/images/fileicon.png"
                                                    alt="file icon"
                                                    style={{ width: '150px', height: '150px' }}
                                                />
                                            )}
                                        </div>

                                        <div className='descriptionblock'>
                                            <p><strong>{file.file_name}</strong></p>
                                            <p>{file.description}</p>
                                            <p><small>{file.project_name}</small></p>
                                        </div>

                                    </div>

                                    <div className='vl_dsh_buttonholder'>
                                        <button className='mr-10' onClick={() => handleView(file)}>
                                            View
                                        </button>

                                        <button className='mr-10' onClick={() => handleDownload(file)}>
                                            Download
                                        </button>
                                    </div>

                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            </div>
            <div className='vl_dsh_popup_vis nodisplay' id="addfile">
                <div className='vl_dsh_pop_content'>
                    <button className='vl_dsh_pop_content_close' onClick={closeAddFilePOP}>+</button>
                    <h2 className='vl_dsh_pop_content_heading'>Upload Files</h2>
                    <div className='upload_section'>
                        <div className='formfieldholder'>
                            <textarea id="file_description" placeholder='Insert File purpose'></textarea>
                        </div>
                        <div className='formfieldholder'>
                            <input type="file" id="project_file" />
                        </div>
                        <div className='buttonholder'>
                            <button onClick={uploadfiles}>Uplaod</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
             {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                         <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
